import React from 'react';
import PropTypes from 'prop-types';
import { connect } from '@gasbuddy/react';
import GridColumns from '../../grid-columns';
import BrandInfo from './brand-info';
import BrandingsPropType from '../../../utils/prop-types/brandings';
import BrandPropType from '../../../utils/prop-types/brand';
import InputWithLabel from '../../input-with-header';
import styles from './styles.css';

const BrandViewContent = ({ allBrands, hideBrandInfo, brandings, displayName }) => {
  let fuelBrand;
  let cstoreBrand;

  if (brandings.fuel_brand_id) {
    fuelBrand = allBrands.find(ab => ab.id === brandings.fuel_brand_id);
  }
  if (brandings.cstore_brand_id) {
    cstoreBrand = allBrands.find(ab => ab.id === brandings.cstore_brand_id);
  }
  return (
    <>
      <GridColumns
        container
        className={hideBrandInfo ? styles.hideBrandInfo : ''}
        contents={[
          {
            key: 'fuelBrand',
            title: undefined,
            body: (
              <div className={styles.brandWrapper}>
                <BrandInfo isFuelBrand brand={fuelBrand} hideBrandInfo={hideBrandInfo} />
              </div>
            ),
          },
          {
            key: 'cstoreBrand',
            title: undefined,
            body: (
              <div className={`${styles.brandWrapper} ${styles.secondBrandPadding}`}>
                <BrandInfo isCstoreBrand brand={cstoreBrand} hideBrandInfo={hideBrandInfo} />
              </div>
            ),
          },
        ]}
      />
      {!hideBrandInfo
        && (
          <InputWithLabel
            label="Public Display Name"
            className={styles.displayNameInput}
            value={displayName}
          />
        )
      }
    </>
  );
};

BrandViewContent.propTypes = {
  brandings: BrandingsPropType,
  displayName: PropTypes.string,
  allBrands: PropTypes.arrayOf(BrandPropType),
  hideBrandInfo: PropTypes.bool,
};

BrandViewContent.defaultProps = {
  brandings: undefined,
  displayName: '',
  allBrands: null,
  hideBrandInfo: false,
};

const mapStateToProps = state => ({
  allBrands: state.brands,
  brandings: state.station.brandings,
  displayName: state.station.display_name,
});

export default connect(mapStateToProps)(BrandViewContent);
